// Display modes only an installed PWA window reports. `fullscreen` is left
// out: a browser tab reports it too (F11, Fullscreen API), and the app has
// its own fullscreen mode.
const INSTALLED_DISPLAY_MODES = [
  "standalone",
  "minimal-ui",
  "window-controls-overlay",
];

// `matchMedia` is missing in JSDOM, where the tests load this module via App.
const matchesInstalledMode = (): boolean =>
  (typeof window.matchMedia === "function" &&
    INSTALLED_DISPLAY_MODES.some(
      (mode) => window.matchMedia(`(display-mode: ${mode})`).matches
    )) ||
  (navigator as { standalone?: boolean }).standalone === true;

// Latched: a window's launch mode never changes, but an installed window
// entering fullscreen reports `fullscreen` and would otherwise lose its
// status. Seeded at load, before any fullscreen is possible.
let installed = false;

// An installed PWA window has no tab bar: a `_blank` there is handed to the
// system browser. In-app links must navigate in place instead, and keep
// opening a tab in a plain browser.
export const isInstalledWindow = (): boolean => {
  if (!installed) installed = matchesInstalledMode();
  return installed;
};

isInstalledWindow();

export const inAppLinkTarget = (): "_self" | "_blank" =>
  isInstalledWindow() ? "_self" : "_blank";
